// A job's model as people read it (G1 decision 31): its name in the catalog, as live's rows and
// previews show a model's title, never its id; the id where the catalog no longer lists it.
// My Generations' row titles a Layerize as live does ("Seedream 5.0 Pro · Layerize", live's
// `LAYERIZE_GENERATION_MODEL_TITLE`). ⓘ (`GenerationFacts`) and the AI Actors' rows read it too.
import type { Catalog, Job } from "../../api/generated/model";

/** The model's name in the catalog, of any medium; its id where the catalog does not list it. */
export function modelName(catalog: Catalog | undefined, id: string): string {
  const models = [
    ...(catalog?.image_models ?? []),
    ...(catalog?.video_models ?? []),
    ...(catalog?.audio_models ?? []),
    ...(catalog?.text_models ?? []),
  ];
  return models.find((model) => model.id === id)?.name ?? id;
}

/** A generation's model as its row titles it: its name, a Layerize's with live's " · Layerize". */
export function modelTitle(catalog: Catalog | undefined, job: Pick<Job, "type" | "model">): string | null {
  if (job.model === null) return null;
  const name = modelName(catalog, job.model);
  return job.type === "image.layerize" ? `${name} · Layerize` : name;
}
